import { render, staticRenderFns } from "./EmailUpdate.vue?vue&type=template&id=4cbee472&"
import script from "./EmailUpdate.vue?vue&type=script&lang=ts&"
export * from "./EmailUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports